import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import {
  BLUE_A,
  BLUE_B,
} from '../constants/Colors';
import { reportError } from './reportError';
import { markupParser, reactRenderer } from './parser';

const jssStyles = {
  default: {
    '& p': {
      margin: '1em 0',
    },
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      margin: '1em 0',
      verticalAlign: 'bottom',
    },
    '& em': {
      fontWeight: 'normal',
      fontStyle: 'italic',
    },
    '& strong': {
      fontWeight: 'bold',
      fontStyle: 'normal',
    },
    '& a': {
      color: BLUE_A,
    },
    '& a:hover': {
      color: BLUE_B,
    },
    '& ul': {
      paddingLeft: '1.5em',
      margin: '1em 0',
      listStyleType: 'disc',
    },
    '& ol': {
      paddingLeft: '1.5em',
      margin: '1em 0',
      listStyleType: 'decimal',
    },
  },
};

const FormattedBlockText = ({
  text,
  classes,
  showError = false,
}) => {
  try {
    // “Note that since many rules expect blocks to end in "\n\n",
    // we append that to source input manually,
    // in addition to specifying inline: false (inline: false is technically optional
    // for all of the default rules, which assume inline is false if it is undefined).”
    // Source: https://github.com/Khan/simple-markdown#putting-it-all-together
    const parseTree = markupParser(`${text}\n\n`, { inline: false });
    const outputResult = reactRenderer(parseTree);
    return (
      <div
        className={classes.default}
        data-testid="formatted-block-text"
      >
        {outputResult}
      </div>
    );
  } catch (error) {
    if (showError) {
      const errormessage = `RenderFormattedText received invalid rules: ${error}`;
      reportError(error);
      return (
        <div
          className={classes.default}
          data-testid="formatted-block-text"
        >
          {errormessage}
        </div>
      );
    } else {
      return (
        <div
          className={classes.default}
          data-testid="formatted-block-text"
        >
          {text}
        </div>
      );
    }
  }
};

FormattedBlockText.propTypes = {
  text: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  showError: PropTypes.bool,
};

export default injectSheet(jssStyles)(FormattedBlockText);
